export default "__VITE_ASSET__CcRpTfm1__"